import { StateInterface } from 'client/Interfaces/StateInterface'
import { exchangeRateSelector } from 'client/reducers/exchangeRate'
import { Dispatch } from 'redux'

import * as api from '../api/exchangeRate'
import { ExchangeRateInterface } from '../Interfaces/ExchangeRateInterface'
import { actionCreatorAsync } from './index'

export function getExchangeRate() {
  return (dispatch: Dispatch, getState: () => StateInterface): void => {
    const exchangeRate = exchangeRateSelector(getState())
    if (exchangeRate) {
      return
    }
    dispatch(
      actionCreatorAsync<ExchangeRateInterface>('GET_EXCHANGE_RATE', async () => {
        return (await api.getExchangeRate()) || {}
      }),
    )
  }
}
